import moment from 'moment'
import jwtDecode from 'jwt-decode'

export default {
    // a missing or unreadable token counts as expired
    isJwtExpired(jwtToken) {
        if (!jwtToken || jwtToken === 'null') return true
        try {
            const decodedJwtToken = jwtDecode(jwtToken)
            return moment().unix() > decodedJwtToken.exp
        } catch (e) {
            return true
        }
    },

    /**
     * Return an array of roles found in common JWT claim names.
     * Returns null if token is falsy or no roles found.
     */
    getRoles(jwtToken) {
        if (!jwtToken) return null
        try {
            const decoded = jwtDecode(jwtToken)
            if (!decoded) return null

            // Common claim names for roles/authorities
            if (decoded.role) return Array.isArray(decoded.role) ? decoded.role : [decoded.role]
            if (decoded.roles) return Array.isArray(decoded.roles) ? decoded.roles : [decoded.roles]
            if (decoded.authorities) {
                if (Array.isArray(decoded.authorities)) return decoded.authorities
                // sometimes authorities come as comma-separated string
                if (typeof decoded.authorities === 'string') return decoded.authorities.split(',').map(s => s.trim()).filter(Boolean)
            }
            if (decoded.scope) {
                if (typeof decoded.scope === 'string') return decoded.scope.split(' ').filter(Boolean)
                if (Array.isArray(decoded.scope)) return decoded.scope
            }
            if (decoded.scopes) return Array.isArray(decoded.scopes) ? decoded.scopes : [decoded.scopes]

            return null
        } catch (e) {
            // If decoding fails, return null to indicate no roles available
            return null
        }
    },

    /**
     * Return the first role (string) or null if none.
     */
    getRole(jwtToken) {
        const roles = this.getRoles(jwtToken)
        return roles && roles.length ? roles[0] : null
    }
}
